module.exports = __webpack_public_path__ + "img/H-45-ST-1000-BE.84c72ba5.png";